import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { LogoMark } from "@/components/Logo";

const NotFound = () => (
  <>
    <Seo
      title="Page Not Found | JC Colors Remodeling LLC"
      description="The page you're looking for isn't here. Explore our painting and drywall services across the Kansas City metro."
    />
    <section
      className="mx-auto flex max-w-7xl flex-col items-start px-4 py-24 sm:px-6 sm:py-32 lg:px-12"
      data-testid="not-found-page"
    >
      <LogoMark size={56} />
      <p className="mt-8 font-mono-accent text-xs uppercase tracking-[0.25em] text-amber-700">
        404 — Wrong wall
      </p>
      <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
        This page isn't on our ladder.
      </h1>
      <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-600">
        The page you're looking for doesn't exist or has moved. Head back home
        or request a free estimate for your painting or drywall project.
      </p>
      <div className="mt-8 flex flex-wrap gap-4">
        <Link
          to="/"
          data-testid="not-found-home-button"
          className="inline-flex items-center gap-2 rounded-full border-2 border-slate-900 px-7 py-3 text-sm font-semibold text-slate-900 transition-colors duration-200 hover:bg-slate-900 hover:text-white"
        >
          Back to Home
        </Link>
        <Link
          to="/contact"
          data-testid="not-found-estimate-button"
          className="inline-flex items-center gap-2 rounded-full bg-amber-600 px-7 py-3 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:scale-105 hover:bg-amber-700"
        >
          Get a Free Estimate
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  </>
);

export default NotFound;
